module.exports = __webpack_public_path__ + "static/media/siddharth-coorg-trip-09.35f23cb4.png";